<template>
  <v-app>
    <v-dialog v-model="loading" fullscreen transition="fade-transition">
      <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
        <v-layout justify-center align-center>
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>

    <router-view></router-view>
  </v-app>
</template>

<script>
import { EventBus } from "./event-bus";

export default {
  name: "App",
  data: () => ({
    loading: false
  }),
  mounted() {
    EventBus.$on("startLoading", () => (this.loading = true));
    EventBus.$on("stopLoading", () => (this.loading = false));
  }
};
</script>

<style>
* {
  font-family: "Montserrat", "Roboto", sans-serif !important;
}
</style>